<section class="invoice-page" id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <div class="header">
        <h3 class="title" i18n="log page title|The title of the log page shown to authenticated users@@logPageTitle">Task History</h3>
        <button class="btn btn-info btn-refresh-logs" (click)="onRefreshClick()" type="button"><i class="fa fa-refresh"></i></button>
      </div>
      <div *ngIf="error.active">
        <div class="alert alert-danger">{{ error.message }}</div>
        <pre style="display: none">{{ error.stack }}</pre>
      </div>
      <div *ngIf="!error.active" class="content">
        <app-filterable-paginated-table
          [columns]="columns"
          [data]="rows"
          [pageSize]="10"
          [loading]="loading"
          [paginationButtonsAllowed]="15"
          width="100%"
        ></app-filterable-paginated-table>
        <table></table>
      </div>
    </section>
  </section>
</section>
